export const getLinkPageVideo = (value) => {
  try {
    const url = new URL(
      /^https?:\/\//i.test(value || "") ? value : `https://${value}`
    );
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    if (
      [
        "youtube.com",
        "m.youtube.com",
        "youtube-nocookie.com",
        "youtu.be",
      ].includes(host)
    ) {
      const id =
        host === "youtu.be"
          ? url.pathname.slice(1).split("/")[0]
          : url.searchParams.get("v") ||
            url.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)/)?.[1];
      if (/^[\w-]{11}$/.test(id || ""))
        return {
          provider: "YouTube",
          embedUrl: `https://www.youtube-nocookie.com/embed/${id}`,
          thumbnail: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
        };
    }

  } catch {
    /* The editor displays validation before publishing. */
  }
  return null;
};

export const invalidLinkPageItem = (item) => {
  if (item.isVisible === false) return false;
  if (item.type === "text") return !item.title?.trim() && !item.subtitle?.trim();
  if (item.type === "ticker") return !item.links?.some((line) => line.title?.trim());
  if (item.type === "reactions" || item.type === "articles") return false;
  if (item.type === "events")
    return !item.links?.length || item.links.some((event) => !event.title?.trim() || !/^\d{4}-\d{2}-\d{2}$/.test(event.date || ""));
  if (!item.title?.trim()) return true;
  if (item.type === "booking") return item.variant === "pick" && !item.value?.trim();
  if (item.type === "socialRow")
    return !item.links?.length || item.links.some((link) => !link.url?.trim());
  if (item.type === "contact") return !item.value?.trim();
  if (item.type === "video") return !getLinkPageVideo(item.url);
  return !item.url?.trim();
};

// Migrate stored Vimeo videos to linked cards; the add-video flow stays YouTube-only.
export const isLegacyVimeoBlock = (item) => {
  if (item?.type !== "video") return false;
  try {
    const url = new URL(item.url);
    return ["vimeo.com", "player.vimeo.com"].includes(url.hostname.replace(/^www\./, "")) && /^\/(?:video\/)?\d+(?:\/|$)/.test(url.pathname);
  } catch { return false; }
};
